import {css} from '@emotion/css';
import {Breakpoints, mq} from '@fo/shared/styles/mixins';
import {colours, spacing} from '@fo/shared/styles/variables';

const styles = {
  container: css`
    label: forgotPasswordModal;
    padding-top: ${spacing.XS};

    ${mq(Breakpoints.TABLET)} {
      padding-top: 0;
    }
  `,
  copy: css`
    label: forgotPasswordModal__copy;
    color: ${colours.font.ASSISTIVE};
  `,
};

export default styles;
